import styled from '@emotion/styled/macro';
import { FC } from 'react';
import { spin } from './Loading.styles';
import { LoadingProps, LoadingVariants } from './Loading.types';

const LoadingSvg: FC<LoadingProps> = ({ variant, size, className }) => {
  return variant === LoadingVariants.Secondary ? (
    <svg width='15' height='16' viewBox='0 0 15 16' fill='none' className={className}>
      <circle
        cx='7.5'
        cy='8.25'
        r='6.48649'
        fill='#E21216'
        stroke='url(#paint0_linear_9019_67144)'
        strokeWidth='2.02703'
      />
      <defs>
        <linearGradient
          id='paint0_linear_9019_67144'
          x1='11.5212'
          y1='12.2205'
          x2='4.52795'
          y2='-0.195072'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.0114028' stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
      </defs>
    </svg>
  ) : (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' className={className}>
      <circle cx='8' cy='8.25' r='6.48649' fill='white' stroke='url(#paint0_linear_9020_67156)' strokeWidth='2.02703' />
      <defs>
        <linearGradient
          id='paint0_linear_9020_67156'
          x1='11.75'
          y1='17.5'
          x2='5.02795'
          y2='-0.195072'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.0114028' stopColor='#E21216' />
          <stop offset='1' stopColor='#E21216' stopOpacity='0' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Loading = styled(LoadingSvg)`
  animation: ${spin} 1.5s ease-in-out infinite;
`;

export default Loading;
